/**
 * @author Herobiam Heita
 * @email hherobiam@gmail.com
 * @create date 2023-04-17 12:09:53
 * @modify date 2023-04-17 12:09:53
 * @desc [description]
 */

export enum LocationActionTypes {
    GET_ALL_LOCATIONS = "get-all-locations",
    GET_SELECTED_LOCATION = "get-selected-location",
    CREATE_LOCATION = "create-location",
    SYNC_LOCATIONS= "sync-locations",
    SYNC_LOCATIONS_ERROR= "sync-locations-error",
    CREATE_LOCATION_ERROR= "create-location-error",
    LOCATION_SUCCESS = "location-success",
    UPDATE_LOCATION = "update-location",
}
